<template>
  <div id="upload-referral-page" class="mb-5" :key="$route.name">
    <div class="flex-grow my-8 px-3">
      <h1>{{ `${$t('Upload')} ${$t(modelName)}` }}</h1>
    </div>
    <vs-row>
      <vs-col>
        <div class="vx-card p-0">
          <upload-form :modelName="modelName" :model="model"/>
        </div>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col>
        <portal-target name="form-buttons"/>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import UploadForm from "./UploadForm";

export default {
  components: {
    UploadForm,
  },
  props: {
    modelName: {
      type: String,
      required: true,
    },
    model: {
      type: String,
      required: true,
    },
  },
  data() {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
  #upload-referral-page {
    width: 100%;
  }
</style>
